const $ = jQuery;

$('.accordion-sidebar-bellow-handle').on('click', function () {
	const bellowParent = $(this).closest('.accordion-sidebar-bellow');
	const key = bellowParent.attr('data-accordion-sidebar-key');

	$('.accordion-sidebar-bellow')
		.not(bellowParent)
		.find('.accordion-sidebar-bellow-content')
		.slideUp('slow');

	if (bellowParent.is('.is-expandable')) {
		const bellowContent = bellowParent.find('.accordion-sidebar-bellow-content');
		if (bellowContent.is(':visible')) {
			bellowContent.slideUp('slow');
		} else {
			bellowContent.slideDown('slow');
		}
	}

	if (bellowParent.is('.is-rotate-image')) {
		// eslint-disable-next-line prettier/prettier
		const bellowImage = $('.accordion-sidebar-bellow-image[data-accordion-sidebar-key="' + key + '"]' );
		if (!bellowImage.is('.accordion-sidebar-bellow-active')) {
			$(this)
				.closest('.block-accordion-sidebar')
				.find('.accordion-sidebar-bellow-image')
				.removeClass('accordion-sidebar-bellow-active');
			bellowImage.addClass('accordion-sidebar-bellow-active');
		}
	}
});
